module.exports = __webpack_public_path__ + "assets/img/LightBackground.0255fa63.svg";